import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { EpaApi } from '../../../../services'
import { WellWaterSystemCoordinatesInitialState } from '../wellWaterSystemCoordinates.slice'

export const createWellWaterSystemCoordinatesAsync = createAsyncThunk(
  'coordinates/wellWaterSystemCoordinates',
  async (geoblockIds: string[], { rejectWithValue }) => {
    try {
      const req = await EpaApi.createWellWaterSystemCoordinates(geoblockIds)
      return (req as AxiosResponse<any, any>).data
    } catch (error: any) {
      console.error(error)
      return rejectWithValue({message:"unknown error occured"})
    }
  },
)

export const createWellWaterSystemCoordinatesAsyncBuilder = (
  builder: ActionReducerMapBuilder<WellWaterSystemCoordinatesInitialState>,
) => {
  builder.addCase(createWellWaterSystemCoordinatesAsync.pending, (state, action) => {
    state.loading = true
    state.success = false
    state.error = ''
  })
  builder.addCase(createWellWaterSystemCoordinatesAsync.fulfilled, (state, action: PayloadAction<any>) => {
    state.loading = false
    state.success = true
    state.data = action.payload
  })
  builder.addCase(createWellWaterSystemCoordinatesAsync.rejected, (state, action: PayloadAction<any>) => {
    state.loading = false
    state.success = true
    state.error = action.payload
  })
}
